import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import QuiltedImageList from './QuiltedImageList';
import ClientProvider from './client';
export default createDemo(import.meta.url, QuiltedImageList, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/image-list/demos/quilted/QuiltedImageList.tsx",
    "fileName": "QuiltedImageList.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import ImageList from '@mui/material/ImageList';\nimport ImageListItem from '@mui/material/ImageListItem';\n\nfunction srcset(image: string, size: number, rows = 1, cols = 1) {\n  return {\n    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,\n    srcSet: `${image}?w=${size * cols}&h=${\n      size * rows\n    }&fit=crop&auto=format&dpr=2 2x`,\n  };\n}\n\nexport default function QuiltedImageList() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ImageList\n      sx={{ width: 500, height: 450 }}\n      variant=\"quilted\"\n      cols={4}\n      rowHeight={121}\n    >\n      {itemData.map((item) => (\n        <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>\n          <img\n            {...srcset(item.img, 121, item.rows, item.cols)}\n            alt={item.title}\n            loading=\"lazy\"\n          />\n        </ImageListItem>\n      ))}\n    </ImageList>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n\nconst itemData = [\n  {\n    img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',\n    title: 'Breakfast',\n    rows: 2,\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',\n    title: 'Burger',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',\n    title: 'Camera',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',\n    title: 'Coffee',\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',\n    title: 'Hats',\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',\n    title: 'Honey',\n    author: '@arwinneil',\n    rows: 2,\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',\n    title: 'Basketball',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',\n    title: 'Fern',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',\n    title: 'Mushrooms',\n    rows: 2,\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',\n    title: 'Tomato basil',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',\n    title: 'Sea star',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',\n    title: 'Bike',\n    cols: 2,\n  },\n];\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 93,
        "focusedLines": 16,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import ImageList from '@mui/material/ImageList';\nimport ImageListItem from '@mui/material/ImageListItem';\n\nfunction srcset(image: string, size: number, rows = 1, cols = 1) {\n  return {\n    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,\n    srcSet: `${image}?w=${size * cols}&h=${\n      size * rows\n    }&fit=crop&auto=format&dpr=2 2x`,\n  };\n}\n\nexport default function QuiltedImageList() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ImageList\n      sx={{ width: 500, height: 450 }}\n      variant=\"quilted\"\n      cols={4}\n      rowHeight={121}\n    >\n      {itemData.map((item) => (\n        <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>\n          <img\n            {...srcset(item.img, 121, item.rows, item.cols)}\n            alt={item.title}\n            loading=\"lazy\"\n          />\n        </ImageListItem>\n      ))}\n    </ImageList>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n\nconst itemData = [\n  {\n    img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',\n    title: 'Breakfast',\n    rows: 2,\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',\n    title: 'Burger',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',\n    title: 'Camera',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',\n    title: 'Coffee',\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',\n    title: 'Hats',\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',\n    title: 'Honey',\n    author: '@arwinneil',\n    rows: 2,\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1516802273409-68526ee1bdd6',\n    title: 'Basketball',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1518756131217-31eb79b20e8f',\n    title: 'Fern',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1597645587822-e99fa5d45d25',\n    title: 'Mushrooms',\n    rows: 2,\n    cols: 2,\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1567306301408-9b74779a11af',\n    title: 'Tomato basil',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1471357674240-e1a485acb3e1',\n    title: 'Sea star',\n  },\n  {\n    img: 'https://images.unsplash.com/photo-1589118949245-7d38baf380d6',\n    title: 'Bike',\n    cols: 2,\n  },\n];\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageList"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "width"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "500"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "height"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "450"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "quilted",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "cols"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "4"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "rowHeight"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "121"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            "    >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "      ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "itemData"
              ],
              ".",
              [
                "span",
                "pl-en",
                "map"
              ],
              "((",
              [
                "span",
                "pl-v",
                "item"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageListItem"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "img"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "cols"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-c1 di-jv",
                "cols"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "||"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "rows"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-c1 di-jv",
                "rows"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "||"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "          <",
              [
                "span",
                "pl-ent",
                "img"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "            ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-en",
                "srcset"
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "img"
              ],
              ", ",
              [
                "span",
                "pl-c1 di-num",
                "121"
              ],
              ", ",
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-c1 di-jv",
                "rows"
              ],
              ", ",
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-c1 di-jv",
                "cols"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "alt"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "item"
              ],
              ".",
              [
                "span",
                "pl-c1 di-jv",
                "title"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "            ",
              [
                "span",
                "pl-e di-ak",
                "loading"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "lazy",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            "          />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageListItem"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      ))",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ImageList"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 93,
    "focusedLines": 16,
    "collapsible": true,
    "externals": [
      "@mui/material/ImageList",
      "@mui/material/ImageListItem"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
